/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd, HiFolderAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const CertificateCreate = () => {
  const { certificateApi } = apiPath;
  const { aboutUsCertificateList } = RoutePath;
  const navigate = useNavigate();

  // if (certificateContentLoading) {
  //   return <Loading />;
  // }

  // const { description, title, _id } = certificateContentData[0];

  const data = [
    {
      elementType: "input",
      label: "Certificate title",
      type: "Text",
      name: "title",
      required: false,
    },
    {
      elementType: "textField",
      label: "Certificate description",
      type: "Text",
      name: "description",
      required: false,
    },
    {
      elementType: "input",
      label: "Certificate date",
      type: "Text",
      name: "date",
      required: false,
    },
    {
      elementType: "file",
      label: `Certificate Image`,
      name: "certificate_img",
      type: "file",
      fullCol: true,
      required: false,
    },
  ];

  const update = async (data) => {
    const { certificate_img, ...rest } = data;
    rest.image = {
      url: certificate_img,
    };
    rest.identifier = data.title;
    const res = await updateData(certificateApi, rest, null, true); // add to api
    if (!!res?.length) {
      setTimeout(() => {
        window.location.href = "/" + aboutUsCertificateList;
      }, 600);

    }
  };

  return (
    <div>
      <div className="md:pl-14 mt-4 mb-8">
        <h1 className="font-bold text-xl md:text-2xl -mb-10 uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new certificate
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default CertificateCreate;
